import logoIcon from "../../../assets/logo.png";
import wholesumWordmark from "../../../assets/wholesum.png";
import indianFast from "../../../assets/indianFast.png";
import basketImg from "../../../assets/baskit.png";

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto grid min-h-screen w-full max-w-[1180px] grid-cols-1 items-center gap-10 px-6 py-10 lg:grid-cols-2">
        {/* LEFT BRAND */}
        <div className="flex items-center justify-center">
          <div className="flex w-full max-w-[520px] flex-col items-center text-center">
            <div className="mb-6 grid h-[150px] w-[150px] place-items-center rounded-full bg-[#f7fbfb]">
              <img
                src={logoIcon}
                alt="WholeSum icon"
                className="h-[170px] w-[170px] object-contain select-none"
                draggable={false}
              />
            </div>

            <img
              src={wholesumWordmark}
              alt="WholeSum"
              className="h-[105px] w-auto select-none"
              draggable={false}
            />

            <div className="mt-3 h-[2px] w-[409px] bg-[#f2c6cc]" />

            <div className="mt-8 flex items-center justify-center gap-3">
              <img
                src={indianFast}
                alt="India's Fastest Grocery Delivery App"
                className="h-20 w-auto select-none"
                draggable={false}
              />

              <img
                src={basketImg}
                alt="Basket"
                className="h-11 w-11 -translate-y-3 rotate-[20deg] select-none -translate-x-[84px]"
                draggable={false}
              />
            </div>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="flex items-center justify-center lg:justify-end">
          <div className="w-full max-w-[520px]">{children}</div>
        </div>
      </div>
    </div>
  );
}